import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';
import { reducer as jPlayers } from 'react-jplayer';


// Styles the jPlayer to look nice
//import 'react-jplayer/src/less/skins/sleek.less';
// Styles Play/Pause/Mute etc when icons (<i />) are used for them
//import 'react-jplayer/src/less/controls/iconControls.less';


import './skins/sleek.css';

import LivePlayer from './livePlayer';

// Pass the jPlayer reducer and it's initialStates to the store
const store = createStore(combineReducers({ jPlayers }));



class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="VitalFM logo" />
        </header>
        <Provider store={store}>
          <LivePlayer />
        </Provider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js